module.exports = __webpack_public_path__ + "static/media/sumeet-sir.37d6ca8f.png";